import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-47acb316"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "news-group-container"
};
const _hoisted_2 = {
  class: "box"
};
const _hoisted_3 = {
  class: "news-group-name"
};
const _hoisted_4 = {
  class: "add-account"
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  class: "pagination-box"
};
import { getNew, delNews, getNewsGroupItem } from '@/api/news';
import { ElMessage, ElMessageBox } from 'element-plus';
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import NewsDialog from './components/NewsDialog';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const {
      groupId
    } = route.params;
    const newsGroupName = ref('');
    const type = ref(0);
    const tenantId = ref(0);
    const getNewsGroupData = async () => {
      const res = await getNewsGroupItem(groupId);
      newsGroupName.value = res.name;
      type.value = res.type;
      tenantId.value = res.tenantId;
    };
    const tableData = ref([]);
    const currentPage = ref(1);
    const total = ref(0);
    const pageSize = ref(8);

    /**
     * 获取广告组分页
     */
    const getNewsData = async () => {
      const res = await getNew({
        currentPage: currentPage.value,
        pageSize: 10,
        groupId: groupId
      });
      tableData.value = res.records.sort((a, b) => a.code - b.code);
      total.value = res.total;
      currentPage.value = res.current;
    };

    // 控制新增广告组隐藏显示
    const newsVisible = ref(false);

    /**
     * 新增广告组
     */
    const addNewsHandler = () => {
      newsVisible.value = true;
    };

    // loading效果
    const loading = ref(false);
    onMounted(() => {
      getNewsGroupData();
      getNewsData();
    });
    /**
     * 删除广告组
     */
    const handleDelNews = async row => {
      try {
        await ElMessageBox.confirm('是否删除该条广告位', '温馨提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        });
        loading.value = true;
        await delNews(row.id);
        ElMessage.success('删除成功');
        await getNewsData();
      } catch (error) {} finally {
        loading.value = false;
      }
    };

    // 修改广告组显示隐藏
    const current = ref(null);
    const handleEditNews = row => {
      current.value = JSON.parse(JSON.stringify(row));
      newsVisible.value = true;
    };

    /**
     * 更改当前页码
     * @param {*} val
     */
    const handleCurrentChange = async val => {
      currentPage.value = val;
      await getNewsData();
    };
    const code = computed(() => {
      if (tableData.value.length === 0) {
        return 0;
      }
      return Math.max(...tableData.value.map(item => item.code)) + 1;
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "title-card",
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(newsGroupName.value), 1), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: addNewsHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })])])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          style: {
            "width": "100%"
          },
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "code",
            label: "序号",
            width: "180"
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "标题"
          }), type.value !== 1 ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            label: "图片"
          }, {
            default: _withCtx(({
              row
            }) => [row.url ? (_openBlock(), _createBlock(_component_el_image, {
              key: 0,
              style: {
                "width": "100px",
                "height": "100px"
              },
              src: row.url,
              "preview-src-list": [row.url],
              "initial-index": 0,
              "zoom-rate": 1.2,
              "preview-teleported": "",
              "hide-on-click-modal": ""
            }, null, 8, ["src", "preview-src-list"])) : (_openBlock(), _createElementBlock("span", _hoisted_5, " 无图片 "))]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "操作",
            width: "240"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: $event => handleEditNews(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 更改 ")]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              type: "danger",
              size: "small",
              onClick: $event => handleDelNews(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 删除 ")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_pagination, {
          class: "pagination",
          onCurrentChange: handleCurrentChange,
          "current-page": currentPage.value,
          "page-size": pageSize.value,
          total: total.value,
          layout: "total,  prev, pager, next, jumper"
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      }), _createVNode(_unref(NewsDialog), {
        modelValue: newsVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => newsVisible.value = $event),
        model: current.value,
        code: code.value,
        onRefreshData: getNewsData,
        onClearModel: _cache[1] || (_cache[1] = $event => current.value = null),
        groupId: _unref(groupId),
        type: type.value,
        tenantId: tenantId.value
      }, null, 8, ["modelValue", "model", "code", "groupId", "type", "tenantId"])]);
    };
  }
};